"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClassName = function (defaultClassName, className) {
    return className
        ? className
            .split(' ')
            .concat(defaultClassName)
            .join(' ')
        : defaultClassName.join(' ');
};
//# sourceMappingURL=classname.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-mapbox-gl/lib/util/classname.js
// module id = 399
// module chunks = 0